import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { UseMutationOptions, useMutation } from 'react-query'
import { SuggestionRequest } from 'types'

interface RefineImageParams {
  image_url: string
  topic: string
  generation_type?: string
}

interface RefineImageResponse {
  request: SuggestionRequest
}

type Options = Omit<UseMutationOptions<RefineImageResponse, Error, RefineImageParams>, 'mutationKey' | 'mutationFn'>

const refineImage = async (
  workspaceId: number,
  designId: string,
  params: RefineImageParams,
): Promise<RefineImageResponse> => {
  const res = await sendToApi<RefineImageResponse>(`/w/${workspaceId}/designs/${designId}/refine_image`, {
    method: 'POST',
    body: {
      image_url: params.image_url,
      topic: params.topic,
      generation_type: params.generation_type || 'refined',
    },
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }

  return res.data
}

export const useRefineImage = (designId: string, options?: Options) => {
  const workspaceId = useCurrentWorkspaceId()
  return useMutation<RefineImageResponse, Error, RefineImageParams>(
    (params) => refineImage(workspaceId, designId, params),
    options,
  )
}
